var JobService = (function (backOffice, $) {
    backOffice.JobService = (function () {
        function create(job, toggleLoader = true, success = null, error = null, complete = null) {
            if (!job) {
                return;
            }

            if (toggleLoader) {
                backOffice.ToggleLoader(true, undefined, ".modal-overlay");
            }

            $.ajax({
                url: window.location.origin + "/dotnet/admin/api/jobs",
                type: "POST",
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(job),
                success: function (data, status, xhr) {
                    if (success) {
                        success(data, status, xhr);
                    }
                },
                error: function (xhr, status, err) {
                    if (error) {
                        error(xhr, status, err);
                    }
                },
                complete: function (xhr, status) {
                    if (complete) {
                        complete(xhr, status);
                    }

                    if (toggleLoader) {
                        backOffice.ToggleLoader(false, undefined, ".modal-overlay");
                    }
                }
            });
        }

        return $.extend(backOffice.JobService, {
            Create: create
        });
    })();

    return backOffice.JobService;

})(BackOffice || {}, jQuery);